<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card>
            <template v-slot:header>
                <h5>Detail Jenis Barang</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                    <b-col>{{ jenisBarang.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tipe Pinjaman</b-col>
                    <b-col>{{ jenisBarang.jenisPinjaman.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kelengkapan</b-col>
                    <b-col v-if="jenisBarang.kelengkapan.length > 0">
                        <ul class="list-none-wrapper">
                            <b-row>
                                <b-col md="4">
                                    <li xs="6" v-for="list in listAktif"  v-bind:key="list.id">
                                        <span> <i class="fa fa-check"></i> {{list.name}}</span>
                                    </li>
                                </b-col>
                                <b-col md="4">
                                    <li xs="6" v-for="list in listNonAktif"  v-bind:key="list.id">
                                        <span> <i class="fa fa-times"></i> {{list.name}}</span>
                                    </li>
                                </b-col>
                            </b-row>
                        </ul>
                    </b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">SPESIFIKASI</h6>
                <b-table bordered hover show-empty :fields="spesifikasiFields" :busy="isBusy" :items="jenisBarang.spesifikasi" responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada spesifikasi untuk jenis barang ini.
                    </template>
                    <template v-slot:cell(nominalAngka)="row">
                        <div class="text-right no wrap" v-if="row.item.nominalAngka == null">{{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                        <div class="text-right no wrap text-danger" v-else-if="row.item.nominalAngka < 0">Rp. {{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                        <div class="text-right no wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalAngka)}} </div>
                    </template>
                    <template v-slot:cell(nominalPersen)="row">
                        <div class="text-right no-wrap" v-if="row.item.nominalPersen == null">{{$helper.addThousandSeparator(row.item.nominalPersen)}} </div>
                        <div class="text-right no-wrap text-danger" v-else-if="row.item.nominalPersen < 100 ">{{$helper.addThousandSeparator(row.item.nominalPersen)}} %</div>
                        <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.nominalPersen)}} %</div>
                    </template>
                    <template v-slot:cell(isActive)="row">
                        <span v-if="(row.item.isActive == true)" class="badge badge-success">aktif</span>
                        <span v-else class="badge badge-danger">non aktif</span>
                    </template>
                </b-table>
            </div>
            <div class="detail-edit-btn">
                <b-button variant="pgiBtn" name="jenisBarangEditBtn" @click="editJenisBarang">Edit</b-button>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'detail-jenis-barang',
    data(){
        return{
            id: null,
            initStatus: 0,
            isBusy: true,
            jenisBarang: {
                jenisPinjaman: []
            },
            spesifikasiFields:[
                { key: "name", label: "Spesifikasi Barang", sortable:true},
                { key: "nominalAngka", label: "Nominal Angka", sortable: true},
                { key: "nominalPersen", label: "Nominal Persen", sortable: true},
                { key: "isActive", label: "Status", sortable: true},
            ],
            listAktif: [],
            listNonAktif: []
        }
    }, 
    
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleJenisBarang = this.$axios.get(`barang-jenis/${this.id}`).then(response => {

                this.jenisBarang = response.data
                for(var x of this.jenisBarang.kelengkapan){
                    if(x.isActive == true){
                        this.listAktif.push({
                            id: x.id,
                            name: x.name,
                        })
                    }else if(x.isActive == false){
                        this.listNonAktif.push({
                            id: x.id,
                            name: x.name,
                        })
                    }
                }

                this.toggleBusy()   

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getSingleJenisBarang]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        editJenisBarang(){
            this.$router.push({
                path: `${this.$route.path}/edit`
            })
        }

    },

    created(){
        this.init()
    }
}
</script>
